import Vue from "vue";
import SvgIcon from "@/components/SvgIcon";// svg component

// register globally
Vue.component("SvgIcon", SvgIcon);

const req = require.context("./svg", true, /\.svg$/);
const requireAll = requireContext => requireContext.keys().map(requireContext);
requireAll(req);



// WEBPACK FOOTER //
// ./src/icons/index.js